module.exports = __webpack_public_path__ + "img/EA.c389af06.png";